import '../../../../Components/Form/form.css'

import { TextField } from '../../../../Components/Form'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { readKey, travellerFields } from '../Functions'
import { Icon } from '../Icons'
import { SectionShell } from '../SectionShell'
import { getDiffStatus } from './Functions'

const language = cap.language.state || 'IT'
const langMap = { EN: 'en', FR: 'fr' }
const lang = langMap[language] || 'it'
const t = translations[language]

const fieldsById = travellerFields.reduce((acc, f) => ({ ...acc, [f.id]: f }), {})

const DIFF_TO_STATE = { new: 'new', changed: 'changed' }

export const TravellerMidOfficeSection = ({
  state: [state, setState],
  readOnly,
  onClickClear,
  diff,
  // Su una conversazione agentica `requestFromForm` non legge `profileData`
  // (leggi il modulo API, non modificarlo: legge solo `requestDataTransfer` e
  // `infoServices`) — quindi "Modifica viaggiatore" salverebbe una scelta che sparisce
  // in silenzio. Va dichiarato e tolto di mezzo, non lasciato lì a sembrare utile.
  agenticLocked = false
}) => {
  const fields = [
    'pid',
    'name',
    'lastname',
    'email',
    'clientCode',
    'clientBusinessName',
    'clientCity',
    'clientStreet'
  ]

  return (
    <SectionShell
      id="traveller"
      icon="user"
      title={t.datiViaggiatore?.toUpperCase() || 'DATI VIAGGIATORE'}
      storageKey="gigiForm.section.traveller-midoffice"
      contentId="traveller-midoffice-grid"
    >
      <div className="ff-grid">
        {fields.map((id) => {
          const f = fieldsById[id]
          if (!f) return null
          return (
            <div className="ff-grid__item" key={id}>
              <TextField
                id={`traveller-${id}`}
                label={f.label?.[lang] ?? id}
                value={readKey(state, f.location) ?? ''}
                onChange={() => {}}
                disabled
                diffStatus={DIFF_TO_STATE[getDiffStatus(f, diff)]}
              />
            </div>
          )
        })}
      </div>
      {!readOnly && !agenticLocked && (
        <button type="button" className="gf-modify-btn" onClick={onClickClear}>
          <Icon name="edit" size={12} />
          {t.modificaViaggiatore}
        </button>
      )}
    </SectionShell>
  )
}
